/* eslint-disable @typescript-eslint/naming-convention */
import type { DropdownBlock } from '@ps/web-martech-cms-types/Form';
import { StarsDropDown } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-validators';
import React from 'react';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import formStyles from '../CMSForm.scss';
import { getErrorMessage } from '../utils';

import { TXTCLI_Required } from './DropdownSelector.messages.json';
import styles from './DropdownSelector.scss';

const DropdownSelector: React.FC<DropdownBlock['dropdown']> = ({
  field_name,
  label,
  dropdown_options,
  required_validation
}) => {
  const defaultOption = dropdown_options.find((o) => o.default);

  return (
    <StarsDropDown
      id={field_name}
      className={styles.dropdown}
      label={label}
      labelContent={
        required_validation.active && <span className={formStyles.requiredIndicator}>*</span>
      }
      options={dropdown_options}
      defaultOption={defaultOption}
      validators={
        required_validation.active
          ? [required(getErrorMessage(required_validation, TXTCLI_Required))]
          : []
      }
    />
  );
};
export default DropdownSelector;
